import { selector } from 'recoil';
import APIService from '../../APIService';
import { Apis } from '../../app.constants';
import { RecoilAtomKey } from '../../recoilConstantKey';
import { generateFilterKey } from '../../../utils/helper';
import { flowsTableStateAtom } from './flowEditor';

export const fetchFlowListSelector = selector({
  key: RecoilAtomKey.fetchFlowListSelectorKey,
  get: async ({ get }) => {
    const state = get(flowsTableStateAtom);
    const filterKey = generateFilterKey(state.filters);
    if (state.cache[filterKey]) {
      return {
        data: state.cache[filterKey],
        totalCount: state.totalCountCache[filterKey],
        fromCache: true,
      };
    }

    try {
      const response = await APIService.get(`${Apis.getFlowList}?next_page=${state?.filters?.page +1|| 1}&search=${state?.filters?.search}&page_limit=${state?.filters?.rowsPerPage || 10}&organisation_id=${state?.filters?.organisationId || ''}&bot_number=${state?.filters?.botNumber || ''}`);
      if (response?.status === 200)
        return {
          data: response?.data?.list || [],
          totalCount: response?.data?.count || 0,
          fromCache: false,
        };
    } catch (error) {
      return { data: [], totalCount: 0, fromCache: false };
    }
  },
});
